import styled from "styled-components";
import { TestingConstants } from "../../CommonUI/Testing/TestingConstants";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const ActionWrapper = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
`;

export const StyledDataTypeRender = styled.div`
    .DataTypePicker-root {
        .DataTypePicker-select {
            .MuiSelect-select {
                font-size: 10px;
                line-height: 1;
            }

            .MuiSvgIcon-root {
                width: 20px;
                height: 20px;
            }
        }

        .DataTypePicker-edit {
            margin-left: 0px;
        }
    }
`;

export const EditColumnWrapper = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    border-radius: 4px;
    background: ${UIStyleConstants.WHITE_COLOR};
    border: 1px solid ${UIStyleConstants.GRAY_VERY_LIGHT_COLOR};
    box-sizing: border-box;
    border-radius: 4px;
`;

export const EditColumnAction = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PassedTestRow = styled.div<{ columnsSpan: number; y: number; x?: number }>`
    border: 2px solid ${TestingConstants.BORDER_SUCCESS};

    margin: -4px;

    grid-column-start: ${(props) => props.x || 1};
    grid-column-end: ${(props) => props.columnsSpan + (props.x || 1)};

    grid-row-start: ${(props) => props.y + 1};
    grid-row-end: ${(props) => props.y + 2};
`;
